import Vue from 'vue'
import iView from 'view-design'
import VCalendar from 'v-calendar'
// import 'v-calendar/lib/v-calendar.min.css'
import locale from 'view-design/dist/locale/ru-RU'
import { VMoney } from 'v-money'
import moment from 'moment'
import VueMq from 'vue-mq'
import axios from 'axios'

import App from './app.vue'
import router from './router'
import store from './store'
import mainSocket from './sockets/main'

import './styles/themes/index.less'

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start()
  next()
})

router.afterEach(route => {
  iView.LoadingBar.finish()
})

Vue.config.productionTip = false

Vue.use(iView, {
  transfer: true,
  size: 'small',
  locale
})

Vue.use(mainSocket)
Vue.use(VCalendar, {
  firstDayOfWeek: 2,
  masks: {
    weekdays: 'WWW'
  }
})

moment.locale('ru')

Vue.use(VueMq, {
  breakpoints: {
    md: 1300,
    lg: Infinity
  }
})

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  console.log('error', error)
  console.log('error.status', error.response.status)
  if (error.response.status === 401) {
    setTimeout(() => {
      window.location.href = '/saml/init'
    }, 100)
  }
  return Promise.reject(error)
})

// get module permissions mixins
const permissionsMixin = {
  methods: {
    getCommonModulePerms (module, type) {
      return this.$store.getters.getCommonModulePerms(module, type)
    },
    getContractModulePerms (module, type) {
      return this.$store.getters.getContractModulePerms(module, type)
    }
  }
}

Vue.mixin(permissionsMixin)

const VueApp = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

VueApp.$Message.config({ duration: 3 })

Vue.directive('focus', {
  inserted: function (el) {
    el.focus()
  }
})
Vue.directive('money', VMoney)

export default VueApp
